import { Settings } from '../Settings';
import { $window, $body } from '../Constants';
import Nav from './Nav';
import Header from './Header';

/**
 * Nav Sub Horizontal
 */
const NavSubHorizontal = (() => {
  // Constants
  const DATA_KEY = 'ig.nav-sub-horizontal';
  const EVENT_KEY = `.${DATA_KEY}`;

  /**
   * Selector
   */
  const Selector = {
  	MENU_SUB: '.menu-sub',
    LEVEL_1: '.level-1'
  };

  /**
   * ClassName
   */
  const ClassName = {
    SCROLLED: 'scrolled'
  };

  /**
   * Event
   */
  const Event = {
    RESIZE: `resize${EVENT_KEY}`,
    SCROLL: `scroll${EVENT_KEY}`
  };

  /**
   * NavSubHorizonal
   *
   * @class
   * @augments Nav
   */
  class NavSubHorizontal extends Nav {
    /**
     * @constructor
     */
    constructor($element) {
      super($element);

      this._$level1 = null;
      this._scrolledAt = 0;
      this._currentTopValue = 0;
    }

    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      this._$level1 = this.$element.find(Selector.LEVEL_1);

      this.updateScrolledAt();
      this._toggleScrolled();
      super.onReady();
    }

    /**
     * Adjusts the top value
     *
     * @return void
     */
    adjustTopValue() {
      let top = Header.getHeight();

      if (Settings.hideMetaBarOnScrolled) {
        if (Header.isScrolled) {
          top -= Header.metaBarHeight;
        }
      }

      if (this._currentTopValue !== top) {
        this._currentTopValue = top;
        this._$level1.css('top', top);
      }
    }

    /**
     * Updates the scrolled at position
     *
     * @return void
     */
    updateScrolledAt() {
      let scrolledAt = this.$element.offset().top - Header.getHeight();

      if (Settings.hideMetaBarOnScrolled) {
        if (Header.isScrolled) {
          scrolledAt += Header.metaBarHeight;
        }
      }

      this._scrolledAt = scrolledAt;
    }

    // Private

    /**
     * Binds the event handlers to the elements
     *
     * @return void
     */
    _bindHandlers() {
      $window.on(Event.RESIZE, () => {
        this._toggleScrolled();
      });

      $window.on(Event.SCROLL, () => {
        this._toggleScrolled();
      });
    }

    _toggleScrolled() {
      if (Settings.fixedHorizontalSubMenu) {
        // activate scrolled state when Header docks on the subMenu
        this.$element.toggleClass(ClassName.SCROLLED, $window.scrollTop() >= this._scrolledAt);
        this.$element.css('height', this._$level1.height() + 1);
        // set top value for fixed menu
        this.adjustTopValue();
      }
    }
  }

  return NavSubHorizontal._getElement($body.find(Selector.MENU_SUB), NavSubHorizontal);
})();

export default NavSubHorizontal;
